import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoadingSpinner from '../core/components/LoadingSpinner';
import { authService } from '../features/auth/services/authService';

// Lazy load route components
const Home = React.lazy(() => import('./Views/Home'));
const Detail = React.lazy(() => import('./Views/Detail'));
const Admin = React.lazy(() => import('./Views/Admin'));
const Archive = React.lazy(() => import('./Views/Archive'));
const AdminLogin = React.lazy(() => import('../features/auth/components/AdminLogin'));
const CMSPage = React.lazy(() => import('../features/newsletter-editor/pages/NewsletterManagementPage'));

function App() {
  const [user, setUser] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    // Use authService's getCurrentUser to check auth state
    const unsubscribe = authService.onAuthStateChanged((user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="keydiscovery-app">
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          {/* Home page */}
          <Route path="/" element={<Home />} />
          
          {/* Newsletter routes */}
          <Route path="/archive" element={<Archive />} />
          <Route path="/newsletter/:id" element={<Detail />} />
          
          {/* Admin routes */}
          <Route
            path="/admin"
            element={
              user ? <Admin /> : <Navigate to="/admin/login" replace />
            }
          />
          <Route
            path="/admin/login"
            element={
              user ? <Navigate to="/admin/cms" replace /> : <AdminLogin />
            }
          />
          <Route
            path="/admin/cms"
            element={
              user ? <CMSPage /> : <Navigate to="/admin/login" replace />
            }
          />

          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App; 